$(function () {

  $("#g-menu__btn").click(function () {
    console.log("menu");
    $(this).toggleClass("active");
    $("#nav").toggleClass("panelactive");
    //$("#nav-bg").toggleClass("panelactive");
  });
  $("#nav a").click(function () {
    $("#g-menu__btn").toggleClass("active");
    $("#nav").toggleClass("panelactive");
  });

  $(".news__btn-tab__list__item").click(function () {
    $(".news__btn-tab__list__item").removeClass("active");
    $(".news__btn-tab__panel").removeClass("active");
    $(this).toggleClass("active");

    var index = $(".news__btn-tab__list__item").index(this);
    $(".news__btn-tab__panel").eq(index).addClass("active");
  });

  $(".nav__top.open").click(function () {
    var findElm = $(this).next(".nav__lower");
    $(findElm).slideToggle();
    $(this).toggleClass("active");
  });

  $(".qa-list__item__q").click(function () {
    $(this).toggleClass("active");
    $(this).next(".qa-list__item__a").slideToggle();
  });

  $(window).scroll(function () {
    $(".fadein").each(function () {
      var position = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > position - windowHeight + 200) {
        $(this).addClass("active");
      }
    });
  });

});

$(window).on("load", function () {});
